import { DigitalExamQuestion as DigitalExamQuestionType } from './digitalExamPage.types'

export interface DigitalExamQuestionProps {
  question: DigitalExamQuestionType
  questionIndex: number
  selectedAnswerId?: string
  clearAnswerButtonText: string
  onAnswerChange: (answerId: string) => void
  onAnswerClear: () => void
}

export const DigitalExamQuestion = ({
  question,
  questionIndex,
  selectedAnswerId,
  clearAnswerButtonText,
  onAnswerChange,
  onAnswerClear,
}: DigitalExamQuestionProps) => {
  const hasSelection = Boolean(selectedAnswerId)

  return (
    <fieldset className='digital-exam-page__question'>
      <legend className='digital-exam-page__legend'>
        {questionIndex + 1}. {question.text}
      </legend>
      <div className='digital-exam-page__answers' role='radiogroup'>
        {question.answers.map((answer) => (
          <label key={answer.id} className='digital-exam-page__answer'>
            <input
              type='radio'
              name={`${question.id}-${answer.id}`}
              value={answer.id}
              checked={selectedAnswerId === answer.id}
              onChange={() => onAnswerChange(answer.id)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault()
                  onAnswerChange(answer.id)
                }
              }}
            />
            <span>{answer.text}</span>
          </label>
        ))}
      </div>
      {hasSelection && (
        <div className='digital-exam-page__question-actions'>
          <button
            type='button'
            className='digital-exam-page__clear-answer'
            onClick={onAnswerClear}
          >
            {clearAnswerButtonText}
          </button>
        </div>
      )}
    </fieldset>
  )
}
